import script from "./UpdateProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&setup=true&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=3ff71700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff71700"]])

export default __exports__